import { useDebouncedEffect, useOnElementResize } from '@anton.bobrov/react-hooks';
import { ScrollBar } from '@anton.bobrov/vevet-init';
import { useState, useEffect } from 'react';

function useScrollbar({ element, wrapperElement, updateKey }) {
  const parent = element?.parentElement || null;
  const [instance, setInstance] = useState(null);
  useEffect(() => {
    if (!element || !parent) {
      return void 0;
    }
    const bar = new ScrollBar({
      container: element,
      domParent: parent,
      canAutoHide: false
    });
    setInstance(bar);
    return () => {
      bar.destroy();
    };
  }, [element, parent]);
  useDebouncedEffect(() => instance?.resize(), [instance, updateKey], 1);
  useOnElementResize(wrapperElement, () => instance?.resize());
}

export { useScrollbar };
//# sourceMappingURL=useScrollbar.js.map
